"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
/**
 * Configurations table for root entities.
 * Loads all root categories, as all root categories can have summary page (i.e. dynamic portfolio + overview).
 */
var SummaryPageConfigsTableComponent = /** @class */ (function () {
    function SummaryPageConfigsTableComponent(currentLanguageProvider, kbService) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.kbService = kbService;
        this.searchCriteria = '';
        this.search$ = new ReplaySubject_1.ReplaySubject(1);
        this.search$.next(this.searchCriteria);
    }
    SummaryPageConfigsTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.rootCategories$ = this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.switchMap(function (language) {
            return _this.search$.asObservable().pipe(operators_1.switchMap(function (searchText) {
                return _this.getRootCategories().pipe(operators_1.map(function (categories) {
                    return _this.filterCategoriesBySearchText(categories, searchText, language.getId());
                }));
            }));
        }));
    };
    SummaryPageConfigsTableComponent.prototype.getRootCategories = function () {
        return this.kbService.getMainEntityMetaCategories()
            .pipe(operators_1.map(function (metaCategories) {
            return Array.from(metaCategories).filter(function (category) { return category.getIsRoot; });
        }));
    };
    SummaryPageConfigsTableComponent.prototype.filterCategoriesBySearchText = function (categories, searchText, languageId) {
        return categories.filter(function (category) {
            return category.getDisplayNameMultilingual() &&
                category.getDisplayNameMultilingual().getValue(languageId).toLowerCase().includes(searchText.toLowerCase());
        });
    };
    SummaryPageConfigsTableComponent.prototype.searchFilter = function (criteria) {
        this.search$.next(criteria);
    };
    SummaryPageConfigsTableComponent.prototype.closeFilter = function () {
        this.searchCriteria = '';
        this.showSearchInput = false;
        this.search$.next(this.searchCriteria);
    };
    SummaryPageConfigsTableComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-summary-page-configs-table',
            styles: [require('./summary-page-configs-table.component.css')],
            template: require('./summary-page-configs-table.component.html'),
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_kb_service_client_js_1.KbService])
    ], SummaryPageConfigsTableComponent);
    return SummaryPageConfigsTableComponent;
}());
exports.SummaryPageConfigsTableComponent = SummaryPageConfigsTableComponent;
//# sourceMappingURL=summary-page-configs-table.component.js.map